{
  "version": 1,
  "asset_id": "e8119fa3-da77-479f-8f1b-535cc7aa931f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e8119fa3-da77-479f-8f1b-535cc7aa931f/hiatal-type-iv-patient-before-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e8119fa3-da77-479f-8f1b-535cc7aa931f/hiatal-type-iv-patient-before-es-800.webp",
  "original_filename": "hiatal-type-iv-patient-before-es-800.webp",
  "size": 58174,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:53Z"
}
